import classNames from 'classnames/bind';
import styles from './FaqAnswer.module.scss';
import { Heading, RichText } from '@/components';
import { FaqQuestions } from '../FaqQuestions/FaqQuestions';
import { FaqFeedback } from '../FaqFeedback/FaqFeedback';
let cx = classNames.bind(styles);

export function FaqAnswer({ id, title, answer, relatedQuestions, basePath }) {

	return (
		<>
			<Heading level="h2" className='is-style-heading-lead-body'>{title}</Heading>
			<RichText className={cx(['answer'])} html={answer} />
			<div className={cx(['question-feedback'])}>
				<Heading level="h3" className={cx(['feedback-heading', 'is-style-heading-body'])}>
					Was this answer helpful?
				</Heading>
				<FaqFeedback id={id} />
			</div>
			<FaqQuestions questions={relatedQuestions.questions} pagePath={basePath} title="Related Questions" relatedQuestions={true} />
		</>
	);
}
